import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './NavBarBanner.css';
import { FaBars, FaTimes } from 'react-icons/fa';

const NavBarBanner = () => {
  const [navOpen, setNavOpen] = useState(false);
  const [profileRoute, setProfileRoute] = useState("/profile");
  const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    // Profile route logic
    const role = localStorage.getItem("role");
    if (role === "alumni") {
      setProfileRoute("/profile/alumni");
    } else if (role === "student") {
      setProfileRoute("/profile/student");
    } else {
      setProfileRoute("/profile");
    }

    // Scroll handler
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      setIsSticky(scrollPosition > 120); // 120 is approximate banner height
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleNav = () => {
    setNavOpen(!navOpen);
  };

  return (
    <div className="nav-banner-wrapper">
      {/* Banner - normal document flow */}
      <div className="banner">
        <Link to="/" className="logo1">
          <img src="/images/vips-logo.png" alt="Logo" className="logo-image" />
        </Link>
        <div className="institute-text">
          <h1>Vivekananda Institute of Professional Studies - Technical Campus</h1>
          <p>
            Approved by AICTE, Accredited Grade "A++" Institution by NAAC, NBA Accredited, 
            Recognized under Section 2(f) by UGC, Affiliated to <br />
            <span className="mid-text">GGSIP University, Recognized by Bar Council of India, ISO 9001:2015 Certified</span>
          </p>
        </div>
        <div className="right-logo">
          <img src="/images/right-logo.png" alt="Right Logo" className="right-logo" />
        </div>
      </div>

      {/* Navbar - becomes sticky when scrolling */}
      <div className={`navbar-container ${isSticky ? 'sticky' : ''}`}>
        <nav className="navbar">
          <Link to="/" className="logo">
            <img src="./images/logo.jpg" alt="Logo" className="logo-image" />
          </Link>

          <div className="mobile-btn" onClick={toggleNav}>
            {navOpen ? <FaTimes size={30} color="white" /> : <FaBars size={30} color="white" />}
          </div>

          <ul className={`nav-menu ${navOpen ? "active" : ""}`}>
            <li><Link to="/" className="nav-link" onClick={toggleNav}>ABOUT</Link></li>
            <li><Link to="/pages/career-dashboard" className="nav-link" onClick={toggleNav}>CAREERS</Link></li>
            <li><Link to="/pages/student-dashboard" className="nav-link" onClick={toggleNav}>STUDENTS</Link></li>
            <li><Link to="/pages/alumni-container" className="nav-link" onClick={toggleNav}>ALUMNI</Link></li>
            <li><Link to="/pages/faculty" className="nav-link" onClick={toggleNav}>TEAM ARC</Link></li>
            <li><Link to="/pages/media-page" className="nav-link" onClick={toggleNav} >MEDIA</Link></li>
            {/* <li className="search-link">
              <Link to="/search" onClick={toggleNav}><i className="fa fa-search"></i></Link>
            </li> */}
            <li className="profile-icon">
              <Link to={profileRoute} onClick={toggleNav}>
                <i className="fa fa-user"></i>
              </Link>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  );
};

export default NavBarBanner;